import { useState, useRef, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const PROJECTS = [
  {
    id: 1,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet01.webp',
    title: 'Uroczysko Polańczyk',
    subtitle: 'Luksusowy obiekt noclegowy',
    category: 'Turystyka & Noclegi',
    url: 'uroczyskopolanczyk.com',
    color: '#00d4ff',
    result: '+210% rezerwacji online',
    tags: ['Strona Premium', 'Agent AI', 'Local SEO', 'Google Wizytówka'],
    desc: 'Kompleksowa transformacja cyfrowa ekskluzywnego ośrodka w Polańczyku. Nowa strona z agentem AI obsługującym rezerwacje i zapytania 24/7, zoptymalizowana pod lokalne słowa kluczowe — efekt: dominacja w wynikach Google dla regionu Bieszczad i wzrost rezerwacji o ponad 210% w ciągu 6 miesięcy.',
  },
  {
    id: 2,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet02.webp',
    title: 'Rajskie Uroczysko',
    subtitle: 'Apartamenty premium w Bieszczadach',
    category: 'Turystyka & Noclegi',
    url: 'rajskieuroczysko.pl',
    color: '#00ff88',
    result: 'Top 3 Google · +180% zapytań',
    tags: ['Strona Premium', 'Agent AI', 'SEO', 'Galeria 360°'],
    desc: 'Luksusowy ośrodek w Bieszczadach zyskał nowoczesną stronę z wirtualnymi spacerami 360° i agentem AI. Klienci mogą "zwiedzić" obiekt przed rezerwacją — skróciło to ścieżkę decyzyjną i dramatycznie zwiększyło zaufanie oraz współczynnik konwersji.',
  },
  {
    id: 3,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet03.webp',
    title: 'FallHouse',
    subtitle: 'Luksusowe apartamenty premium',
    category: 'Turystyka & Noclegi',
    url: 'fallhouse.pl',
    color: '#ff6b9d',
    result: 'Automatyzacja + SEO regionalne',
    tags: ['Strona Premium', 'Automatyzacja AI', 'SEO', 'Google Maps'],
    desc: 'Strona dla ekskluzywnego domu wakacyjnego w Bieszczadach z automatyzacją AI do obsługi zapytań i wstępnej kwalifikacji gości. Zintegrowany system kalendarza dostępności i automatyczne potwierdzenia mailowe eliminują ręczną pracę operacyjną.',
  },
  {
    id: 4,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet04.webp',
    title: 'Biesy i Czady – Pizzeria',
    subtitle: 'Restauracja & Pizzeria',
    category: 'Gastronomia',
    url: 'pizzeria-polanczyk.pl',
    color: '#00d4ff',
    result: 'Menu online + Agent na zamówienia',
    tags: ['Strona', 'Menu Online', 'Agent AI', 'Local SEO'],
    desc: 'Pizzeria w Polańczyku wdrożyła nowoczesną stronę z interaktywnym menu i agentem AI przyjmującym zamówienia i rezerwacje stolików. System automatycznie informuje o dostępności i szacowanym czasie oczekiwania na zamówienie.',
  },
  {
    id: 5,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet05.webp',
    title: 'Gazdówka Cisna',
    subtitle: 'Dom wypoczynkowy w Cisnej',
    category: 'Turystyka & Noclegi',
    url: 'gazdowkacisna.pl',
    color: '#00ff88',
    result: '+300% widoczność na mapach Google',
    tags: ['Strona', 'Google Wizytówka', 'Local SEO', 'Fotografia'],
    desc: 'Gazdówka w malowniczej Cisnej potrzebowała silnej obecności w lokalnych wynikach. Nowa strona, zoptymalizowana wizytówka Google i kampania zdobywania opinii sprawiły, że obiekt pojawia się w top 3 dla wszystkich kluczowych zapytań regionu.',
  },
  {
    id: 6,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet06.webp',
    title: 'Dębowa Gazdówka',
    subtitle: 'Obiekt noclegowy / gościniec',
    category: 'Turystyka & Noclegi',
    url: 'debowagazdowka.eu',
    color: '#ff6b9d',
    result: 'Rebrand + dominacja w lokalnym SEO',
    tags: ['Rebrand Cyfrowy', 'Strona', 'Local SEO', 'Google Wizytówka'],
    desc: 'Kompleksowy rebrand cyfrowy tradycyjnej gazdówki w Bieszczadach. Nowa strona zachowuje autentyczny charakter obiektu, jednocześnie prezentując go nowoczesnym językiem wizualnym. Optymalizacja wizytówki Google przyniosła natychmiastową widoczność na mapach.',
  },
  {
    id: 7,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet07.webp',
    title: 'FALLWOOD – Bębny Drewniane',
    subtitle: 'Producent bębnów kablowych',
    category: 'Przemysł & B2B',
    url: 'fallwood.pl',
    color: '#00d4ff',
    result: 'Strona B2B + generowanie leadów',
    tags: ['Strona B2B', 'Lead Generation', 'SEO techniczne', 'UX Design'],
    desc: 'Strona firmowa dla producenta drewnianych bębnów kablowych. Projekt skupia się na prezentacji produktów i specyfikacji technicznych dla klientów B2B, generowaniu zapytań ofertowych oraz budowaniu wizerunku rzetelnego producenta przemysłowego.',
  },
  {
    id: 8,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet08.webp',
    title: 'FALLWOOD – Pellet',
    subtitle: 'Producent ekologicznego pelletu',
    category: 'Przemysł & B2B',
    url: 'fallwood.pl',
    color: '#00ff88',
    result: 'E-commerce B2B + dystrybucja online',
    tags: ['Strona B2B', 'E-commerce', 'SEO', 'Ekologia'],
    desc: 'Strona firmowa dla producenta ekologicznego pelletu. Implementacja systemu zamówień B2B online, kalkulator zapotrzebowania na pellet dla indywidualnych klientów oraz zoptymalizowane SEO pod frazy produktowe i lokalne.',
  },
  {
    id: 9,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet09.webp',
    title: 'NUTRIFAL',
    subtitle: 'Studio Dietetyki',
    category: 'Zdrowie & Beauty',
    url: 'nutrifal.pl',
    color: '#ff6b9d',
    result: '+65% konwersji na rejestracje',
    tags: ['Strona Premium', 'Agent AI', 'SEO', 'UX Design'],
    desc: 'Studio dietetyki zyskało premium stronę z agentem AI pełniącym rolę wstępnego doradcy — pomaga klientom określić cele zdrowotne i umówić wizytę. Wzrost konwersji na rejestracje o 65% po wdrożeniu agenta AI i redesignie UX.',
  },
  {
    id: 10,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet10.webp',
    title: 'Solińska Restauracja',
    subtitle: 'Pokusa Smaków',
    category: 'Gastronomia',
    url: 'solinskarestauracja.pl',
    color: '#00d4ff',
    result: 'Rezerwacje online + Local SEO',
    tags: ['Strona', 'System Rezerwacji', 'Local SEO', 'Menu Online'],
    desc: 'Elegancka strona restauracyjna nad Jeziorem Solińskim z systemem rezerwacji stolików online, interaktywnym menu i galerią zdjęć potraw. Optymalizacja Local SEO przyniosła wzrost rezerwacji z map Google o ponad 140%.',
  },
  {
    id: 11,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet11.webp',
    title: 'Restauracja Santa Barbara',
    subtitle: 'Nad Jeziorem Solińskim',
    category: 'Gastronomia',
    url: 'santabarbara-solina.pl',
    color: '#00ff88',
    result: 'Premium brand + wzrost reputacji online',
    tags: ['Strona Premium', 'Branding', 'Google Wizytówka', 'SEO'],
    desc: 'Strona premium dla restauracji z pięknym widokiem na Jezioro Solińskie. Projekt kładzie nacisk na budowanie premium wizerunku marki, prezentację wyjątkowej lokalizacji i generowanie rezerwacji bezpośrednich z obejściem portali pośredniczących.',
  },
  {
    id: 12,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet12.webp',
    title: 'Restauracja Kamionka',
    subtitle: 'Smaki Bieszczad',
    category: 'Gastronomia',
    url: 'restauracja-kamionka.pl',
    color: '#ff6b9d',
    result: 'Widoczność lokalna + menu online',
    tags: ['Strona', 'Menu Online', 'Local SEO', 'Google Maps'],
    desc: 'Strona dla restauracji w sercu Bieszczad z tradycyjnymi smakami regionu. Implementacja interaktywnego menu online, systemu obsługi rezerwacji i kampania budowania opinii Google, która przyniosła wzrost liczby wizyt w lokalu.',
  },
  {
    id: 13,
    img: 'https://images.org.pl/orsonet/realizacje/orsonet13.webp',
    title: 'Eureka – Konstrukcje Stalowe',
    subtitle: 'Firma przemysłowa',
    category: 'Przemysł & B2B',
    url: 'eureka-stal.pl',
    color: '#00d4ff',
    result: 'Strona B2B + generowanie zapytań',
    tags: ['Strona Przemysłowa', 'B2B', 'SEO techniczne', 'Lead Gen'],
    desc: 'Strona firmowa dla specjalisty w dziedzinie konstrukcji stalowych i usług przemysłowych. Profesjonalna prezentacja realizacji, specyfikacji technicznych i certyfikatów. Generowanie zapytań B2B poprzez formularze i zoptymalizowane SEO branżowe.',
  },
];

const CATEGORIES = ['Wszystkie', 'Turystyka & Noclegi', 'Gastronomia', 'Zdrowie & Beauty', 'Przemysł & B2B'];

function useSwipe(onSwipeLeft: () => void, onSwipeRight: () => void) {
  const startX = useRef<number | null>(null);
  const startY = useRef<number | null>(null);

  const onTouchStart = useCallback((e: React.TouchEvent) => {
    startX.current = e.touches[0].clientX;
    startY.current = e.touches[0].clientY;
  }, []);

  const onTouchEnd = useCallback((e: React.TouchEvent) => {
    if (startX.current === null || startY.current === null) return;
    const dx = e.changedTouches[0].clientX - startX.current;
    const dy = e.changedTouches[0].clientY - startY.current;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
      if (dx < 0) onSwipeLeft();
      else onSwipeRight();
    }
    startX.current = null;
    startY.current = null;
  }, [onSwipeLeft, onSwipeRight]);

  return { onTouchStart, onTouchEnd };
}

function ProjectSlider({ projects }: { projects: typeof PROJECTS }) {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const autoRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const go = useCallback((idx: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent((idx + projects.length) % projects.length);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning, projects.length]);

  const next = useCallback(() => go(current + 1), [go, current]);
  const prev = useCallback(() => go(current - 1), [go, current]);

  const swipe = useSwipe(next, prev);

  useEffect(() => {
    autoRef.current = setInterval(() => { next(); }, 5000);
    return () => { if (autoRef.current) clearInterval(autoRef.current); };
  }, [next]);

  const resetAuto = useCallback(() => {
    if (autoRef.current) clearInterval(autoRef.current);
    autoRef.current = setInterval(() => { next(); }, 5000);
  }, [next]);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') { go(current + 1); resetAuto(); }
      if (e.key === 'ArrowLeft') { go(current - 1); resetAuto(); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [current, go, resetAuto]);

  const proj = projects[current];

  return (
    <div className="w-full select-none">
      {/* Main slider */}
      <div
        className="relative rounded-3xl overflow-hidden border border-white/10 cursor-grab active:cursor-grabbing"
        style={{ height: 'clamp(360px, 55vw, 640px)' }}
        {...swipe}
      >
        {/* Images preload */}
        {projects.map((p, i) => (
          <img
            key={p.id}
            src={p.img}
            alt={p.title}
            className="absolute inset-0 w-full h-full object-cover object-top"
            style={{
              opacity: i === current ? 1 : 0,
              transition: 'opacity 0.7s cubic-bezier(0.4,0,0.2,1)',
              zIndex: i === current ? 1 : 0,
            }}
          />
        ))}

        {/* Gradient overlays */}
        <div className="absolute inset-0 z-10" style={{ background: 'linear-gradient(to right, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 55%, transparent 80%)' }} />
        <div className="absolute inset-0 z-10" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 40%)' }} />

        {/* Browser bar top */}
        <div className="absolute top-0 left-0 right-0 z-20 flex items-center gap-2 px-5 py-3.5 bg-black/50 backdrop-blur-md border-b border-white/10">
          <div className="flex gap-1.5">
            <span className="w-3 h-3 rounded-full bg-red-500/70" />
            <span className="w-3 h-3 rounded-full bg-yellow-500/70" />
            <span className="w-3 h-3 rounded-full bg-green-500/70" />
          </div>
          <div
            className="flex-1 mx-3 px-3 py-1.5 rounded-md text-xs text-white/50 font-mono flex items-center gap-2 transition-all duration-500"
            style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}
          >
            <i className="ri-lock-2-line text-[10px] text-[#00ff88]" />
            {proj.url}
          </div>
          <div className="flex items-center gap-2 text-xs text-white/30">
            <span>{current + 1}</span>
            <span>/</span>
            <span>{projects.length}</span>
          </div>
        </div>

        {/* Content overlay */}
        <div className="absolute bottom-0 left-0 right-0 z-20 p-8 md:p-12 max-w-[600px]">
          <div
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold mb-4 backdrop-blur-sm"
            style={{ background: `${proj.color}20`, border: `1px solid ${proj.color}40`, color: proj.color }}
          >
            {proj.category}
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-1 leading-tight transition-all duration-500">
            {proj.title}
          </h2>
          <p className="text-white/50 text-sm mb-3 font-medium">{proj.subtitle}</p>
          <p className="font-bold text-base mb-4 transition-all duration-500" style={{ color: proj.color }}>
            <i className="ri-bar-chart-box-line mr-2" />{proj.result}
          </p>
          <p className="text-white/45 text-sm leading-relaxed mb-5 hidden md:block max-w-[480px]">{proj.desc}</p>
          <div className="flex flex-wrap gap-2">
            {proj.tags.map((t) => (
              <span key={t} className="px-2.5 py-1 rounded-lg text-xs font-semibold backdrop-blur-sm"
                style={{ background: `${proj.color}12`, border: `1px solid ${proj.color}30`, color: proj.color }}>
                {t}
              </span>
            ))}
          </div>
        </div>

        {/* Arrow buttons */}
        <button
          onClick={() => { prev(); resetAuto(); }}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-30 w-11 h-11 flex items-center justify-center rounded-full border border-white/20 bg-black/50 backdrop-blur-md hover:bg-white/15 hover:border-white/40 transition-all duration-200 cursor-pointer"
          aria-label="Poprzedni"
        >
          <i className="ri-arrow-left-s-line text-white text-xl" />
        </button>
        <button
          onClick={() => { next(); resetAuto(); }}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-30 w-11 h-11 flex items-center justify-center rounded-full border border-white/20 bg-black/50 backdrop-blur-md hover:bg-white/15 hover:border-white/40 transition-all duration-200 cursor-pointer"
          aria-label="Następny"
        >
          <i className="ri-arrow-right-s-line text-white text-xl" />
        </button>
      </div>

      {/* Thumbnails */}
      <div className="mt-5 flex gap-3 overflow-x-auto pb-2 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
        {projects.map((p, i) => (
          <button
            key={p.id}
            onClick={() => { go(i); resetAuto(); }}
            className="flex-shrink-0 rounded-xl overflow-hidden border-2 transition-all duration-300 cursor-pointer"
            style={{
              width: '100px',
              height: '64px',
              borderColor: i === current ? proj.color : 'rgba(255,255,255,0.1)',
              opacity: i === current ? 1 : 0.5,
              scrollSnapAlign: 'start',
            }}
          >
            <img src={p.img} alt={p.title} className="w-full h-full object-cover object-top" />
          </button>
        ))}
      </div>

      {/* Dot progress bar */}
      <div className="mt-4 flex items-center justify-center gap-1.5">
        {projects.map((_, i) => (
          <button
            key={i}
            onClick={() => { go(i); resetAuto(); }}
            className="cursor-pointer rounded-full transition-all duration-300"
            style={{
              width: i === current ? '24px' : '6px',
              height: '6px',
              background: i === current ? proj.color : 'rgba(255,255,255,0.2)',
            }}
          />
        ))}
      </div>
    </div>
  );
}

function AnimatedSection({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.05 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} style={{ opacity: visible ? 1 : 0, transform: visible ? 'none' : 'translateY(32px)', transition: `opacity 0.65s ease ${delay}s, transform 0.65s ease ${delay}s` }}>
      {children}
    </div>
  );
}

export default function RealizacjePage() {
  const [activeCategory, setActiveCategory] = useState('Wszystkie');

  const filtered = activeCategory === 'Wszystkie'
    ? PROJECTS
    : PROJECTS.filter((p) => p.category === activeCategory);

  return (
    <div className="min-h-screen bg-[#080808] text-white overflow-x-hidden">
      <Navbar />

      {/* Hero */}
      <section className="pt-36 pb-12 px-4 md:px-6 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 60% 0%, rgba(0,212,255,0.09) 0%, transparent 55%)' }} />
        <div className="max-w-[1400px] mx-auto">
          <AnimatedSection>
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start mb-14">
              <div className="flex-1 pt-4">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#00d4ff]/30 bg-[#00d4ff]/5 backdrop-blur-sm mb-7">
                  <span className="w-2 h-2 rounded-full bg-[#00d4ff] animate-pulse" />
                  <span className="text-[#00d4ff] text-xs font-semibold tracking-widest uppercase">Portfolio & Realizacje</span>
                </div>
                <h1 className="text-5xl md:text-6xl xl:text-7xl font-black leading-tight mb-6">
                  Realne projekty<br />
                  <span className="text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(135deg, #00d4ff 0%, #00ff88 100%)' }}>
                    dla firm z różnych branż
                  </span>
                </h1>
                <p className="text-lg text-white/40 max-w-xl leading-relaxed">
                  13 realizacji — od stron premium po agentów AI i systemy B2B. Każdy projekt to konkretna transformacja cyfrowa z mierzalnymi wynikami.
                </p>
                <div className="flex flex-wrap gap-6 mt-8">
                  {[
                    { val: '13+', label: 'Projektów w portfolio', color: '#00d4ff' },
                    { val: '60+', label: 'Aktywnych wdrożeń', color: '#00ff88' },
                    { val: '95%', label: 'Klientów powraca', color: '#ff6b9d' },
                  ].map((s) => (
                    <div key={s.label}>
                      <div className="text-3xl font-black" style={{ color: s.color }}>{s.val}</div>
                      <div className="text-white/35 text-xs mt-0.5">{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Mini grid preview */}
              <div className="flex-shrink-0 grid grid-cols-3 gap-2 w-full lg:w-[360px]">
                {PROJECTS.slice(0, 9).map((p, i) => (
                  <div key={p.id} className="rounded-xl overflow-hidden border border-white/10 hover:border-white/25 transition-all duration-300 cursor-pointer" style={{ height: '80px' }}>
                    <img src={p.img} alt={p.title} className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500" />
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Full slider */}
      <section className="pb-20 px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <AnimatedSection>
            <ProjectSlider projects={PROJECTS} />
          </AnimatedSection>
        </div>
      </section>

      {/* Filter + Grid */}
      <section className="py-16 px-4 md:px-6 bg-[#060606] border-t border-white/5">
        <div className="max-w-[1400px] mx-auto">
          <AnimatedSection>
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-5 mb-10">
              <div>
                <h2 className="text-3xl font-black text-white">Wszystkie realizacje</h2>
                <p className="text-white/35 text-sm mt-1">{filtered.length} projektów</p>
              </div>
              <div className="flex flex-wrap gap-2">
                {CATEGORIES.map((cat) => (
                  <button
                    key={cat}
                    onClick={() => setActiveCategory(cat)}
                    className="px-4 py-2 rounded-full text-xs font-semibold transition-all duration-250 cursor-pointer whitespace-nowrap"
                    style={{
                      background: activeCategory === cat ? 'rgba(0,212,255,0.18)' : 'rgba(255,255,255,0.04)',
                      border: activeCategory === cat ? '1px solid rgba(0,212,255,0.45)' : '1px solid rgba(255,255,255,0.09)',
                      color: activeCategory === cat ? '#00d4ff' : 'rgba(255,255,255,0.45)',
                    }}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            </div>
          </AnimatedSection>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
            {filtered.map((p, idx) => (
              <AnimatedSection key={p.id} delay={idx * 0.06}>
                <div className="group rounded-2xl overflow-hidden border border-white/8 bg-white/[0.02] hover:border-white/18 transition-all duration-400 flex flex-col h-full hover:-translate-y-1">
                  {/* Screenshot */}
                  <div className="relative overflow-hidden" style={{ height: '220px' }}>
                    {/* Browser chrome */}
                    <div className="absolute top-0 left-0 right-0 z-10 flex items-center gap-2 px-3 py-2.5 bg-black/80 backdrop-blur-sm border-b border-white/8">
                      <div className="flex gap-1">
                        <span className="w-2.5 h-2.5 rounded-full bg-red-500/60" />
                        <span className="w-2.5 h-2.5 rounded-full bg-yellow-500/60" />
                        <span className="w-2.5 h-2.5 rounded-full bg-green-500/60" />
                      </div>
                      <div className="flex-1 mx-2 px-2 py-0.5 rounded text-[10px] text-white/30 font-mono flex items-center gap-1 truncate"
                        style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)' }}>
                        <i className="ri-lock-2-line text-[9px] text-[#00ff88]" />{p.url}
                      </div>
                    </div>
                    <img
                      src={p.img}
                      alt={p.title}
                      className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                      style={{ marginTop: '36px', height: 'calc(100% - 36px)' }}
                    />
                    <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0d0d0d] to-transparent" />
                    {/* Category */}
                    <div className="absolute top-12 left-3 z-10">
                      <span className="px-2.5 py-1 rounded-full text-[10px] font-bold backdrop-blur-sm"
                        style={{ background: `${p.color}20`, border: `1px solid ${p.color}40`, color: p.color }}>
                        {p.category}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="text-lg font-black text-white mb-0.5 group-hover:text-[#00d4ff] transition-colors">{p.title}</h3>
                    <p className="text-white/35 text-xs mb-3 font-medium">{p.subtitle}</p>
                    <p className="text-xs font-bold mb-4 flex items-center gap-1.5" style={{ color: p.color }}>
                      <i className="ri-bar-chart-box-line" />{p.result}
                    </p>
                    <p className="text-white/40 text-xs leading-relaxed mb-4 flex-1 line-clamp-3">{p.desc}</p>
                    <div className="flex flex-wrap gap-1.5">
                      {p.tags.map((t) => (
                        <span key={t} className="px-2 py-0.5 rounded-lg text-[10px] font-medium"
                          style={{ background: `${p.color}10`, border: `1px solid ${p.color}25`, color: p.color }}>
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-28 px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <AnimatedSection>
            <div className="text-center mb-14">
              <p className="text-[#00d4ff] text-xs uppercase tracking-[3px] font-semibold mb-4">Wyniki naszych wdrożeń</p>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-4">Technologia AI w liczbach</h2>
              <p className="text-white/35 text-base">Średnie wyniki wdrożeń z naszego aktywnego portfolio klientów</p>
            </div>
          </AnimatedSection>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { val: '60+', label: 'Wdrożeń AI i stron premium', color: '#00d4ff' },
              { val: '80%', label: 'Redukcja czasu obsługi klienta', color: '#00ff88' },
              { val: '24/7', label: 'Agenci AI pracują bez przerwy', color: '#ff6b9d' },
              { val: '+180%', label: 'Średni wzrost rezerwacji online', color: '#00d4ff' },
            ].map((s) => (
              <AnimatedSection key={s.label} delay={0.08}>
                <div className="text-center p-7 rounded-2xl border border-white/9 bg-white/[0.02] hover:border-white/20 transition-all">
                  <div className="text-4xl md:text-5xl font-black mb-3" style={{ color: s.color }}>{s.val}</div>
                  <p className="text-white/40 text-xs leading-relaxed">{s.label}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-28 px-4 md:px-6 bg-[#060606] border-t border-white/5">
        <div className="max-w-[900px] mx-auto text-center">
          <AnimatedSection>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#00ff88]/30 bg-[#00ff88]/5 mb-8">
              <span className="w-2 h-2 rounded-full bg-[#00ff88] animate-pulse" />
              <span className="text-[#00ff88] text-xs font-semibold tracking-widest uppercase">Twój projekt może być następny</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6">Gotowy na AI<br />w swoim biznesie?</h2>
            <p className="text-white/40 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
              Umów bezpłatną konsultację — w 30 minut pokażemy Ci, jak konkretne wdrożenie AI może zmienić wyniki Twojej firmy.
            </p>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 text-black px-10 py-5 rounded-xl font-bold text-lg whitespace-nowrap cursor-pointer hover:scale-105 transition-transform"
              style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)', boxShadow: '0 0 40px rgba(0,212,255,0.25)' }}
            >
              Umów bezpłatną konsultację
              <i className="ri-arrow-right-line" />
            </Link>
          </AnimatedSection>
        </div>
      </section>

      <Footer />
    </div>
  );
}
